import { render } from "./Welcome.vue?vue&type=template&id=e15aad26&scoped=true"
import script from "./Welcome.vue?vue&type=script&lang=js"
export * from "./Welcome.vue?vue&type=script&lang=js"

import "./Welcome.vue?vue&type=style&index=0&id=e15aad26&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e15aad26"

export default script